import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  externalReferences: hasMany('external-reference', { inverse: null }),
  link: belongsTo('link', { inverse: null }),
  organization: belongsTo('organization', { inverse: null }),
});
